module.exports = __webpack_public_path__ + "img/add_user_white.dda1fe05.png";